import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-forget-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './forget-password.component.html',
  styleUrl: './forget-password.component.scss'
})
export class ForgetPasswordComponent implements OnInit {
  forgetPasswordForm!: FormGroup;
  isSubmitting = false;
  successMessage = '';
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient
  ) {
    this.initForm();
  }

  ngOnInit(): void { }

  /**
   * Initialize the reactive form
   */
  private initForm(): void {
    this.forgetPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      cid: ['', [Validators.required, Validators.pattern(/^[0-9]{13}$/)]]
    });
  }

  /**
   * Check if field has error
   */
  hasError(fieldName: string): boolean {
    const field = this.forgetPasswordForm.get(fieldName);
    return !!(field && field.invalid && field.touched);
  }

  /**
   * Get error message for field
   */
  getErrorMessage(fieldName: string): string {
    const field = this.forgetPasswordForm.get(fieldName);
    if (!field || !field.errors) return '';

    if (field.errors['required']) return 'กรุณากรอกข้อมูล';
    if (field.errors['email']) return 'รูปแบบอีเมลไม่ถูกต้อง';
    if (field.errors['pattern']) {
      if (fieldName === 'cid') return 'รหัสบัตรประชาชนต้องเป็นตัวเลข 13 หลัก';
    }

    return 'ข้อมูลไม่ถูกต้อง';
  }

  /**
   * Submit the form
   */
  onSubmit(): void {
    // Mark all fields as touched to show validation errors
    Object.keys(this.forgetPasswordForm.controls).forEach(key => {
      this.forgetPasswordForm.get(key)?.markAsTouched();
    });

    if (this.forgetPasswordForm.valid) {
      this.isSubmitting = true;
      this.errorMessage = '';
      this.successMessage = '';

      const formData = this.forgetPasswordForm.value;

      // Prepare API request body
      const requestBody = {
        email: formData.email,
        cid: formData.cid
      };

      console.log('Forget password request:', requestBody);

      // Call API
      this.http.post(`${environment.apiUrl}/users/forget-password`, requestBody).subscribe({
        next: (response: any) => {
          console.log('Password reset successful:', response);
          this.isSubmitting = false;
          this.successMessage = response.message || 'Password reset successfully. New password has been sent to your email.';
          
          // Redirect to login after 3 seconds
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 3000);
        },
        error: (error) => {
          console.error('Password reset error:', error);
          this.isSubmitting = false;
          
          let errorMessage = 'เกิดข้อผิดพลาดในการรีเซ็ตรหัสผ่าน';

          if (error.error?.message) {
            errorMessage = error.error.message;
          } else if (error.status === 404) {
            errorMessage = 'ไม่พบข้อมูลผู้ใช้ กรุณาตรวจสอบอีเมลและรหัสบัตรประชาชน';
          } else if (error.status === 400) {
            errorMessage = 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง';
          } else if (error.status === 0) {
            errorMessage = 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้';
          }

          this.errorMessage = errorMessage;
        }
      });
    }
  }

  /**
   * Cancel and go back to login
   */
  cancel(): void {
    this.router.navigate(['/login']);
  }
}
